export default __webpack_public_path__ + "static/media/logo.8fea8a82.png";